export default "__VITE_ASSET__ld8dkTxZ__"